var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumbs__item"},[(_vm.item.to)?_c('router-link',{staticClass:"link",attrs:{"to":_vm.item.to}},[_vm._v(_vm._s(_vm.item.text))]):_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.item.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }